import { dateFormatLongMonth, generateCountString } from '@alluradirect/react';
import { BookingCheckoutResponse } from 'components/views/pages/Checkout/hooks/useCheckout';
import { PaymentTypeEnum } from 'components/views/pages/Checkout/types';
import { getNumberOrZero } from 'helpers/numHelpers';
import dayjs from 'dayjs';

export const amountDueToday = (checkoutData: BookingCheckoutResponse | undefined, paymentType: string | undefined) => {
  switch (paymentType) {
    case PaymentTypeEnum.DepositBalanceDue.toString(): {
      return checkoutData?.BOOKING.PAYMENT.DEPOSIT.TOTAL ?? 0;
    }
    case PaymentTypeEnum.PayInFull.toString(): {
      return checkoutData?.BOOKING.PAYMENT.SINGLE.TOTAL ?? 0;
    }
    default: {
      return 0;
    }
  }
};

interface GuestDisplayArgs {
  adults: string | undefined;
  children: string | undefined;
  infants: string | undefined;
}

export const generateGuestsDisplay = (
  { adults, children, infants }: GuestDisplayArgs,
  placeholder?: string | undefined,
): string => {
  const aNum = getNumberOrZero(adults);
  const cNum = getNumberOrZero(children);
  const iNum = getNumberOrZero(infants);

  if (!aNum && !cNum && !iNum) return placeholder ?? 'Add Guests (EDIT) to Continue';

  const a = generateCountString(aNum, 'Adult');
  const c = generateCountString(cNum, 'Child', 'ren');
  const i = generateCountString(iNum, 'Infant');

  return `${a}, ${c}, ${i}`;
};

interface PetsDisplayArgs {
  pets: string | undefined;
  allowsPets: boolean | undefined;
}

export const generatePetsDisplay = ({ pets, allowsPets }: PetsDisplayArgs): string => {
  if (allowsPets === undefined) return '';

  if (!allowsPets) {
    return 'Pets not allowed';
  }

  const numPets = Number(pets);
  if (numPets === 0) return 'Pet friendly - Are you bringing a pet?';

  return generateCountString(Number(pets) ?? 0, 'Pet');
};

interface DatesDisplayArgs {
  startDate: string | undefined;
  endDate: string | undefined;
}

export const generateDatesDisplay = (
  { startDate, endDate }: DatesDisplayArgs,
  placeholder?: string,
): string => {
  if (!startDate || !endDate) {
    return placeholder ?? 'Select Dates (EDIT) to Continue';
  }
  return `${dateFormatLongMonth(dayjs(startDate))} - ${dateFormatLongMonth(dayjs(endDate))}`;
};
